import React from "react";

//Importing Material UI stuff
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import { OutlinedButton } from "../../components/Buttons";

import errorGiphy from "../../assets/placeholders/errorGIF.gif";

import style from "./style";

const ErrorPage = () => {
  const useStyles = makeStyles(style);
  const classes = useStyles();

  return (
    <Grid
      container
      className={`${classes.errorContainer}`}
      data-aos="fade-in"
    >
      <Grid className={`${classes.giphyContainer}`}>
        <img className={classes.img} src={errorGiphy} alt="Error GIF" data-aos="fade-in"/>
      </Grid>
      <Grid className={`${classes.textContainer}`}>
        <Typography variant="h2" data-aos="fade-in" gutterBottom className={classes.title}>
        Page Not Found
        </Typography>
        <Typography variant="h6" data-aos="fade-in" gutterBottom className={classes.description}>
        We couldn’t find what you are looking for. Please check the page URL and try again!
        </Typography>
        <Link to={`/`} className={`${classes.buttonContainer} hover-detect`}>
          <OutlinedButton data-aos="fade-in" size="large">Back to Home</OutlinedButton>
        </Link>
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
